<template>
  <b-modal
    v-if="lobbyOffer"
    id="modal-offer-xmasrush-3"
    class="custom-modal1"
    :hide-footer="true"
    hide-header
    modal-class="custom-modal1"
    @hidden="onHidden"
  >
    <template slot="default">
      <div
        class="close-button"
        @click="$bvModal.hide('modal-offer-xmasrush-3')"
      ></div>
      <div v-if="rewards[0]" class="offer-reward-container1">
        <BaseAsset
          asset="primary"
          size="big"
          style="width: 50px; height: 50px"
        />
        <div v-if="rewards[0].gold > 0">
          <div
            class="bold yellow-text"
            style="font-size: 30px"
            :class="rewards[0].gold.toString().length > 9 ? 'small' : ''"
          >
            {{ formatNumber(rewards[0].gold) }}
          </div>
        </div>

        <!-- <div
          v-if="rewards[0].crown > 0"
          class="w-100 d-inline-flex align-items-center justify-content-center"
        >
          <div class="bold yellow-text" style="font-size: 30px">
            {{ formatNumber(rewards[0].crown) }} x
          </div>
          <BaseAsset asset="secondary" size="big" class="ms-1" />
        </div> -->

        <div class="reward-row d-inline-flex align-items-center w-100 px-3">
          <div v-if="rewards[0].card > 0">
            <BaseAsset asset="cards" size="big" />
            <div class="primary-accent">
              {{ formatNumber(rewards[0].card) }} x
            </div>
          </div>

          <div v-if="rewards[0].loyalty > 0">
            <BaseAsset asset="loyalty" size="big" />
            <div class="primary-accent">
              {{ formatNumber(rewards[0].loyalty) }} x
            </div>
          </div>

          <div v-if="rewards[0].elixir > 0">
            <BaseAsset asset="tertiary" size="big" />
            <div class="primary-accent">
              {{ formatNumber(rewards[0].elixir) }} x
            </div>
          </div>

          <div v-if="rewards[0].expbooster > 0">
            <BaseAsset asset="booster" size="big" />
            <div class="primary-accent">
              {{ Math.round(rewards[0].expbooster / 60) }} Min.
            </div>
          </div>
        </div>
        <div class="submit-button" @click="buyItem(0, 'Offer', 'Lobby')">
          <div>
            {{ $t("shop.offers.buy_button", { 0: "" }) }}
            <br />
            <span class="big position-relative"
              >{{ formatPrice(price[0]) }} €

              <div v-if="oldPrices && oldPrices[0]" class="offer-old-price">
                {{ formatPrice(oldPrices[0]) }} €
                <div class="offer-red-line to-center-abs"></div>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div v-if="rewards[1]" class="offer-reward-container2">
        <div class="icon-gold-container">
          <div class="icon-gold1 to-center-abs">
            <BaseAsset
              asset="primary"
              size="big"
              class="w-100 h-100"
            ></BaseAsset>
          </div>
          <div class="icon-gold2 to-center-abs">
            <BaseAsset
              asset="primary"
              size="big"
              class="w-100 h-100"
            ></BaseAsset>
          </div>
        </div>
        <div v-if="rewards[1].gold > 0">
          <div
            class="bold yellow-text"
            style="font-size: 40px"
            :class="rewards[1].gold.toString().length > 9 ? 'small' : ''"
          >
            {{ formatNumber(rewards[1].gold) }}
          </div>
        </div>
        <!-- <div
          v-if="rewards[1].crown > 0"
          class="w-100 d-inline-flex align-items-center justify-content-center"
        >
          <div class="bold yellow-text" style="font-size: 30px">
            {{ formatNumber(rewards[1].crown) }} x
          </div>
          <BaseAsset asset="secondary" size="big" class="ms-1" />
        </div> -->

        <div class="reward-row d-inline-flex align-items-center w-100">
          <div v-if="rewards[1].card > 0">
            <BaseAsset asset="cards" size="big" />
            <div class="primary-accent">
              {{ formatNumber(rewards[1].card) }} x
            </div>
          </div>

          <div v-if="rewards[1].loyalty > 0">
            <BaseAsset asset="loyalty" size="big" />
            <div class="primary-accent">
              {{ formatNumber(rewards[1].loyalty) }} x
            </div>
          </div>

          <div v-if="rewards[1].elixir > 0">
            <BaseAsset asset="tertiary" size="big" />
            <div class="primary-accent">
              {{ formatNumber(rewards[1].elixir) }} x
            </div>
          </div>

          <div v-if="rewards[1].expbooster > 0">
            <BaseAsset asset="booster" class="h-100" />
            <div class="primary-accent">
              {{ Math.round(rewards[1].expbooster / 60) }} Min.
            </div>
          </div>
        </div>

        <div class="submit-button" @click="buyItem(1, 'Offer', 'Lobby')">
          <div>
            {{ $t("shop.offers.buy_button", { 0: "" }) }}
            <br />
            <span class="big position-relative"
              >{{ formatPrice(price[1]) }} €

              <div v-if="oldPrices && oldPrices[1]" class="offer-old-price">
                {{ formatPrice(oldPrices[1]) }} €
                <div class="offer-red-line to-center-abs"></div>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div v-if="rewards[2]" class="offer-reward-container3">
        <img
          :src="$whitelabel.currencies.primary.triple"
          style="width: 200px"
        />
        <div v-if="rewards[2].gold > 0">
          <div
            class="yellow-text bold"
            style="font-size: 50px"
            :class="rewards[2].gold.toString().length > 9 ? 'small' : ''"
          >
            {{ formatNumber(rewards[2].gold) }}
          </div>
        </div>

        <!-- <div
          v-if="rewards[2].crown > 0"
          class="w-100 d-inline-flex align-items-center justify-content-center"
        >
          <div class="bold yellow-text" style="font-size: 40px">
            {{ formatNumber(rewards[2].crown) }} x
          </div>
          <BaseAsset asset="secondary" size="big" class="ms-1" />
        </div> -->

        <div class="reward-row d-inline-flex align-items-center w-100 px-3">
          <div v-if="rewards[2].card > 0">
            <BaseAsset asset="cards" size="big" />
            <div class="primary-accent">
              {{ formatNumber(rewards[2].card) }} x
            </div>
          </div>

          <div v-if="rewards[2].loyalty > 0">
            <BaseAsset asset="loyalty" size="big" />
            <div class="primary-accent">
              {{ formatNumber(rewards[2].loyalty) }} x
            </div>
          </div>

          <div v-if="rewards[2].elixir > 0">
            <BaseAsset asset="tertiary" size="big" />
            <div class="primary-accent">
              {{ formatNumber(rewards[2].elixir) }} x
            </div>
          </div>

          <div v-if="rewards[2].expbooster > 0">
            <BaseAsset asset="booster" size="big" />
            <div class="primary-accent">
              {{ Math.round(rewards[2].expbooster / 60) }} Min.
            </div>
          </div>
        </div>

        <div class="submit-button" @click="buyItem(2, 'Offer', 'Lobby')">
          <div>
            {{ $t("shop.offers.buy_button", { 0: "" }) }}
            <br />
            <span class="big position-relative"
              >{{ formatPrice(price[2]) }} €

              <div v-if="oldPrices && oldPrices[2]" class="offer-old-price">
                {{ formatPrice(oldPrices[2]) }} €
                <div class="offer-red-line to-center-abs"></div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import offerModalContent from "@/mixins/offerModalContent.js";
import BaseAsset from "@/components/base/base-asset.vue";

export default {
  name: "ModalOfferLobby3",
  components: { BaseAsset },
  mixins: [offerModalContent],
  data() {
    return { isPipelineOffer: true };
  },
  mounted: function () {
    this.$bvModal.show("modal-offer-xmasrush-3");
  },
};
</script>
<style lang="scss">
$modal-width: 1200px;
$modal-height: 900px;

#modal-offer-xmasrush-3 {
  .modal-body {
    padding: 0 !important;
    margin-top: 0 !important;
  }
  .modal-dialog {
    top: 50px;
    max-width: $modal-width;
    height: $modal-height;

    @media (max-height: 750px) {
      transform: scale(0.8);
      top: -60px;
      margin-bottom: -20%;
    }
  }

  .modal-content {
    width: $modal-width;
    background: url(~@/assets/img/shop/offers/xmas_gold_rush_offer_panel.png)
      no-repeat;
    background-size: 100%;
    background-position: 0 -40px !important;
    padding-top: 0 !important;
  }

  .close-button {
    top: -10px;
    right: -10px;
  }
}
</style>

<style scoped lang="scss">
#modal-offer-xmasrush-3 {
  .headline {
    position: absolute;
    top: -46px;
    left: -58px;
  }
  .offer-reward-container1 {
    top: 455px;
    line-height: 0.8;
    text-align: center;
    width: 300px;
    position: absolute;
    left: 90px;
    height: 370px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    justify-content: flex-start;
    .reward-row {
      justify-content: center;
      gap: 12px;
    }
    .submit-button {
      @media screen and (max-width: 1350px) {
        margin-top: 10px;
      }
      width: 160px;
      height: 64px;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #685c00;
      text-transform: uppercase;
      cursor: pointer;
      font-family: Ubuntu-Bold;
      text-align: center;
      display: inline-flex;
      line-height: 1.3;
      font-weight: bold;

      .big {
        color: #685c00;
        font-family: Ubuntu-Bold;
        font-size: 30px;
      }

      .offer-old-price {
        top: -45px;
        right: -180px;
        padding: 0;
        font-size: 25px;
      }
      .big-badge-more-percent {
        top: -390px;
        right: -130px;
      }
    }
  }

  .offer-reward-container2 {
    top: 430px;
    line-height: 1.2;
    text-align: center;
    width: 300px;
    position: absolute;
    right: 100px;
    height: 415px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    justify-content: flex-start;
    .reward-row {
      justify-content: center;
      gap: 12px;
    }
    .icon-gold-container {
      height: 75px;
      margin-bottom: -20px;
      .icon-gold1 {
        z-index: 1;
        width: 50px;
        right: 90px;
        top: 5px;
      }

      .icon-gold2 {
        z-index: 2;
        width: 65px;
        top: -10px;
        right: 10px;
      }
    }

    .bonus-col {
      padding: 0 10%;

      .package-bonus-icons {
        white-space: nowrap;
        margin-left: -10px;
        display: flex;
        align-items: center;
        justify-content: center;

        .package-icon {
          width: 93px;
          text-align: center;
        }

        .package-bonus-icon-card {
          .text {
            color: $primary-accent;
            font-family: Ubuntu;
            font-size: 20px;
            margin-top: 5px;
          }

          .icon {
            height: 42px;
            margin-left: auto;
            margin-right: auto;
          }
        }
        .package-bonus-icon-loyalty {
          .text {
            color: $primary-accent;
            font-family: Ubuntu;
            font-size: 20px;
            margin-top: 5px;
          }

          .icon {
            height: 42px;
            margin-left: auto;
            margin-right: auto;
          }
        }

        .package-bonus-icon-elixir {
          .text {
            color: $primary-accent;
            font-family: Ubuntu;
            font-size: 20px;
            margin-top: 5px;
          }

          .icon {
            height: 42px;
            margin-left: auto;
            margin-right: auto;
          }
        }

        .package-bonus-icon-expbooster {
          .text {
            color: $primary-accent;
            font-family: Ubuntu;
            font-size: 20px;
            margin-top: 5px;
          }

          .icon {
            height: 42px;
            margin-left: auto;
            margin-right: auto;
          }
        }
      }
    }
    .submit-button {
      @media screen and (max-width: 1350px) {
        margin-top: 10px;
      }
      width: 200px;
      height: 72px;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #685c00;
      font-weight: bold;
      text-transform: uppercase;
      cursor: pointer;
      font-family: Ubuntu-Bold;
      text-align: center;
      display: inline-flex;
      line-height: 1.3;

      .big {
        color: #685c00;
        font-family: Ubuntu-Bold;
        font-size: 30px;
      }

      .offer-old-price {
        @media screen and (max-width: 1350px) {
          top: -50px;
          right: -160px;
          padding: 0;
        }
        top: -35px;
        right: -150px;
        padding: 0;
      }
      .big-badge-more-percent {
        top: -460px;
        right: -160px;
      }
    }
  }

  .offer-reward-container3 {
    top: 345px;
    line-height: 1.2;
    text-align: center;
    width: 340px;
    position: absolute;
    left: 430px;
    height: 525px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    justify-content: flex-start;
    .reward-row {
      justify-content: center;
      gap: 12px;
    }
    .submit-button {
      @media screen and (max-width: 1350px) {
        margin-top: 10px;
      }
      width: 350px;
      height: 72px;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #12426c;
      text-transform: uppercase;
      cursor: pointer;
      font-family: Ubuntu-Bold;
      text-align: center;
      padding-left: 28%;
      padding-right: 23%;
      display: inline-flex;
      line-height: 1.1;
      font-weight: bold;

      .big {
        color: #12426c;
        font-family: Ubuntu-Bold;
        font-size: 30px;
      }

      .offer-old-price {
        @media screen and (max-width: 1350px) {
          top: -50px;
          right: -150px;
          padding: 0;
        }
        top: -40px;
        right: -160px;
        padding: 0;
      }
      .big-badge-more-percent {
        top: -480px;
        right: -190px;
      }
    }
  }
}
#modal-offer-xmasrush-3 .close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 9999;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
